/** Single-endpoint analytics ping. No PII. Per spec §15:
 *  POST `{run_id, mode, ended_at, elapsed_real_seconds, completed,
 *   craft_score, quiz_score?, shared?}`. */

export interface AnalyticsPayload {
  run_id: string;
  mode: 'core' | 'endless';
  ended_at: string;
  elapsed_real_seconds: number;
  completed: boolean;
  craft_score: number;
  quiz_score?: number;
  shared?: boolean;
  dso?: number;
}

const ENDPOINT = (typeof process !== 'undefined' && process.env?.ANALYTICS_ENDPOINT) || '';

/** Fire-and-forget POST. In dev (no endpoint configured) just console.log. */
export const sendAnalytics = (payload: AnalyticsPayload): void => {
  if (!ENDPOINT) {
    if (typeof console !== 'undefined') {
      console.info('[analytics:dev]', payload);
    }
    return;
  }
  try {
    void fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // analytics is best-effort; never throw on user
  }
};

export const generateRunId = (): string => {
  const rand = Math.random().toString(36).slice(2, 10);
  const ts = Date.now().toString(36);
  return `run-${ts}-${rand}`;
};
